<template>
  <v-app>
    <v-app-bar
        app
        color="secondary"
        dark
    >
      <div class="d-flex align-center">
        <h1>אבישי נהרי</h1>
      </div>
    </v-app-bar>

    <v-main>
      <HelloWorld/>
    </v-main>
    <v-footer padless>
      <v-col
          class="text-center"
          cols="12"
      >
         אתר זה נבנה ע"י: <strong>אבישי נהרי</strong> - {{ new Date().getFullYear() }}
        <v-divider></v-divider>
        <p>E-mail: a.o.nahari@gmail.com</p>
        <p>052-8693039</p>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>
<style>
.paragraph {
  text-align: right;
}
.paragraph2{
  text-align: right;
}
</style>